import M2hPrivacy from "@/components/M2hPrivacy";
import M2hTos from "@/components/M2hTos";
import M2hP1 from "@/components/M2hP1";
import M2hActivate from "@/components/M2hActivate";
import M2hPassword from "@/components/M2hPassword";
import M2hActivateConfirm from "@/components/M2hActivateConfirm";
import M2hError from "@/components/M2hError";
import M2hComingSoon from "@/components/M2hComingSoon";
import M2hSurvey from "@/components/M2hSurvey";
import M2hPdf from "@/components/M2hPdf";
import M2hLogin from "@/components/M2hLogin.vue";
import M2hProfile from "@/components/M2hProfile.vue";
import M2hConsent from "@/components/M2hConsent.vue";
import M2hDashboard from "@/components/M2hDashboard.vue";
import M2hBrowse from "@/components/M2hBrowse.vue";
import M2hNews from "@/components/M2hNews.vue";
import M2hEvents from "@/components/M2hEvents.vue";
import M2hWatchOnTheGo from "@/components/connections/M2hWatchOnTheGo.vue";
import M2hContent from "@/components/M2hContent.vue";
import M2hWeFitter from "@/components/connections/M2hWeFitter.vue";
import M2hChallenges from "@/components/M2hChallenges.vue";
import M2hChallengesDetail from "@/components/M2hChallengesDetail.vue";
import M2hChallengesWidget from "@/components/M2hChallengesWidget.vue";
import M2hWeFitterBioAge from "@/components/connections/M2hWeFitterBioAge.vue";

const ComponentsPlugin = {
  install(Vue) {
    Vue.component(M2hPrivacy.name, M2hPrivacy)
    Vue.component(M2hTos.name, M2hTos)
    Vue.component(M2hP1.name, M2hP1)
    Vue.component(M2hActivate.name, M2hActivate)
    Vue.component(M2hPassword.name, M2hPassword)
    Vue.component(M2hActivateConfirm.name, M2hActivateConfirm)
    Vue.component(M2hError.name, M2hError)
    Vue.component(M2hComingSoon.name, M2hComingSoon)
    Vue.component(M2hSurvey.name, M2hSurvey)
    Vue.component(M2hPdf.name, M2hPdf)
    Vue.component(M2hLogin.name, M2hLogin)
    Vue.component(M2hProfile.name, M2hProfile)
    Vue.component(M2hConsent.name, M2hConsent)
    Vue.component(M2hDashboard.name, M2hDashboard)
    Vue.component(M2hBrowse.name, M2hBrowse)
    Vue.component(M2hNews.name, M2hNews)
    Vue.component(M2hEvents.name, M2hEvents)
    Vue.component(M2hWatchOnTheGo.name, M2hWatchOnTheGo)
    Vue.component(M2hContent.name, M2hContent)
    Vue.component(M2hWeFitter.name, M2hWeFitter)
    Vue.component(M2hChallenges.name, M2hChallenges)
    Vue.component(M2hChallengesDetail.name, M2hChallengesDetail)
    Vue.component(M2hChallengesWidget.name, M2hChallengesWidget)
    Vue.component(M2hWeFitterBioAge.name, M2hWeFitterBioAge)
  }
};

export { ComponentsPlugin }
